module.exports = __webpack_public_path__ + "assets/img/m_shop.2a38204d.png";